export type FincaraizBlogCategory = {
	slug: string;
	wpCategoryId: number;
	label: string;
	color: string;
	cta: string;
};

export const FINCARAIZ_BLOG_CATEGORIES: FincaraizBlogCategory[] = [
	{
		slug: "noticias",
		wpCategoryId: 271,
		label: "Noticias",
		color: "#077BE7",
		cta: "Leer noticia",
	},
	{
		slug: "informes",
		wpCategoryId: 12,
		label: "Informes",
		color: "#69AD6C",
		cta: "Ver informe",
	},
	{
		slug: "academia",
		wpCategoryId: 2,
		label: "Academia",
		color: "#E8940A",
		cta: "Aprender más",
	},
];

export const FINCARAIZ_WP_REST_BASE = "https://www.fincaraiz.com.co/blog/wp-json/wp/v2";

export const FINCARAIZ_BLOG_DEFAULT_URL = "https://www.fincaraiz.com.co/blog/";

export const FINCARAIZ_POSTS_PER_CATEGORY = 5;
